import { render } from "./NumberInput.vue?vue&type=template&id=1f0fa14c"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"
script.render = render

export default script